function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import GridImageFieldsConfig from "segments/desktop/core-components/grid-image/fields-config";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import BlogCardItemFooterFieldsConfig from "segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/fields-config";
import Constants from "segments/desktop/grid/layouts/blog-cards-grid/constants";
const { link, src } = GridImageFieldsConfig, restFieldsConfig = _object_without_properties(GridImageFieldsConfig, [
    "link",
    "src"
]);
const newSrc = _object_spread_props(_object_spread({}, src), {
    label: `select an image (${Constants.CARD_WIDTH}X${Constants.IMAGE_HEIGHT})`
});
const selectedGridImageFieldsConfig = _object_spread({
    src: newSrc
}, restFieldsConfig);
export default _object_spread_props(_object_spread({
    link: {
        type: FIELD_TYPES.TEXT,
        label: "Blog Link"
    },
    openInNewTab: {
        type: "boolean",
        label: "Should Open In New Tab"
    },
    image: {
        type: FIELD_TYPES.NESTED,
        label: "Image",
        fields: _object_spread({}, selectedGridImageFieldsConfig)
    }
}, TitleConfig), {
    footer: {
        type: FIELD_TYPES.NESTED,
        label: "Card Footer",
        fields: BlogCardItemFooterFieldsConfig
    }
});
